//Script for fading in the back-to-top button and scrolling back up when it is clicked
//Source: https://davidwalsh.name/jquery-top-link
jQuery.fn.topLink = function(settings) {
    settings = jQuery.extend({
        min: 1,
        fadeSpeed: 200
    }, settings);
    return this.each(function() {
        //listen for scroll
        var el = jQuery(this);
        el.hide; //jshint ignore:line
        jQuery(window).scroll(function() {
            if (jQuery(window).scrollTop() >= settings.min) {
                el.fadeIn(settings.fadeSpeed);
            } else {
                el.fadeOut(settings.fadeSpeed);
            }
        });
    });
};

jQuery(document).ready(function() {
    //set the link
    jQuery('#back-to-top').topLink({
        min: 400,
        fadeSpeed: 500
    });
    //smoothscroll
    jQuery('#back-to-top').click(function(e) {
        e.preventDefault();
        jQuery('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });
});
